import React, { useState, useEffect, useRef } from "react";
import styles from "./Counter.module.css";

const CounterItem = ({ img, number, text, type }) => {
  const [count, setCount] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const counterRef = useRef(null);
  const intervalRef = useRef(null);
  const initialAnimationRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        const [entry] = entries;
        if (entry.isIntersecting && !hasStarted) {
          setHasStarted(true);
          startCounterAnimation();
        }
      },
      {
        threshold: 0.5,
        rootMargin: "0px",
      }
    );

    const currentRef = counterRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [hasStarted]);

  const startCounterAnimation = () => {
    const startTime = Date.now();
    const duration = 3000;
    const startValue = 0;
    const endValue = number;

    const animate = () => {
      const now = Date.now();
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const currentValue = Math.round(
        startValue + (endValue - startValue) * easedProgress
      );

      setCount(currentValue);

      if (progress < 1) {
        initialAnimationRef.current = requestAnimationFrame(animate);
      } else {
        setCount(endValue);
        startSecondPhase();
      }
    };

    animate();
  };

  const startSecondPhase = () => {
    if (type != "static") {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      intervalRef.current = setInterval(() => {
        setCount(prev => prev + 1);
      }, 6000);
    }
  };

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (initialAnimationRef.current) {
        cancelAnimationFrame(initialAnimationRef.current);
      }
    };
  }, []);

  return (
    <div ref={counterRef} className={styles.item}>
      <img src={img} alt={text} />
      <div className={styles.number}>{hasStarted ? count : 0}</div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};

export default CounterItem;
